// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateOrder_container__IJRFn {
  animation: CreateOrder_init__KxlkY 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/*---Title---*/
.CreateOrder_container__IJRFn .CreateOrder_titleContainer__u9L3h {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.CreateOrder_container__IJRFn .CreateOrder_titleContainer__u9L3h h4 {
  width: 95%;
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.CreateOrder_container__IJRFn .CreateOrder_titleContainer__u9L3h .CreateOrder_arrow__nnAWf {
  transition: 0.3s;
}

.CreateOrder_container__IJRFn .CreateOrder_titleContainer__u9L3h .CreateOrder_arrow__nnAWf:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.CreateOrder_container__IJRFn .CreateOrder_stepperContainer__IvzIz {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.CreateOrder_container__IJRFn .CreateOrder_stepperButtons__hleLQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.CreateOrder_container__IJRFn .CreateOrder_stepperButtons__hleLQ .CreateOrder_button__PRqMT {
  width: 12rem;
  height: 3rem;
}

.CreateOrder_container__IJRFn .CreateOrder_data__xRMdA {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 50px;
}

@keyframes CreateOrder_init__KxlkY {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 600px) {
  .CreateOrder_container__IJRFn .CreateOrder_stepperButtons__hleLQ .CreateOrder_button__PRqMT {
    width: 40%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/OrdenesPedido/Create/CreateOrder.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  width: 95%;\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .stepperContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .stepperButtons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .stepperButtons .button {\n  width: 12rem;\n  height: 3rem;\n}\n\n.container .data {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 30px;\n  margin-bottom: 50px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .container .stepperButtons .button {\n    width: 40%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CreateOrder_container__IJRFn`,
	"init": `CreateOrder_init__KxlkY`,
	"titleContainer": `CreateOrder_titleContainer__u9L3h`,
	"arrow": `CreateOrder_arrow__nnAWf`,
	"stepperContainer": `CreateOrder_stepperContainer__IvzIz`,
	"stepperButtons": `CreateOrder_stepperButtons__hleLQ`,
	"button": `CreateOrder_button__PRqMT`,
	"data": `CreateOrder_data__xRMdA`
};
export default ___CSS_LOADER_EXPORT___;
